import React, { useCallback, useEffect, useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../providers/auth-provider';
import { getClientConfiguration } from '../../api/client';

function TopNav() {
  const [showLaunch, setShowLaunch] = useState(false);
  const location = useLocation();
  const auth = useAuth();

  const displayNavBar = useCallback(() => {
    return !location?.pathname.startsWith('/report/');
  }, [location]);

  useEffect(() => {
    const config = getClientConfiguration();
    if (auth.isSelect()) {
      setShowLaunch(config?.select?.launch?.assessments?.length > 0);
    } else {
      setShowLaunch(config?.develop?.launch?.assessments?.length > 0);
    }
  }, []);

  return (
    <>
      {displayNavBar() && (
        <Navbar className="ps-3">
          <Nav>
            <LinkContainer to="/">
              <Nav.Link disabled={location.pathname === '/' || location.pathname.startsWith('/client')}>
                Dashboard
              </Nav.Link>
            </LinkContainer>
            {auth.isSelect() ? (
              <>
                <LinkContainer to="/candidates/compare">
                  <Nav.Link disabled={location.pathname === '/candidates/compare'}>Compare</Nav.Link>
                </LinkContainer>
                <LinkContainer to="/participation">
                  <Nav.Link disabled={location.pathname.startsWith('/participation')}>Participation</Nav.Link>
                </LinkContainer>
                {showLaunch && (
                  <LinkContainer to="/launch">
                    <Nav.Link disabled={location.pathname.startsWith('/launch')}>Launch</Nav.Link>
                  </LinkContainer>
                )}
              </>
            ) : (
              <>
                <LinkContainer to="/leaders/compare">
                  <Nav.Link disabled={location.pathname === '/leaders/compare'}>Compare</Nav.Link>
                </LinkContainer>
                <LinkContainer to="/participation">
                  <Nav.Link disabled={location.pathname.startsWith('/participation')}>Participation</Nav.Link>
                </LinkContainer>
                {showLaunch && (
                  <LinkContainer to="/launch">
                    <Nav.Link disabled={location.pathname.startsWith('/launch')}>Launch</Nav.Link>
                  </LinkContainer>
                )}
              </>
            )}
          </Nav>
        </Navbar>
      )}
    </>
  );
}

export default TopNav;
